import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TableComponent from "../../../../components/table/table-component";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { AiFillCaretRight, AiOutlineBell, AiOutlineClose, AiOutlineMail } from "react-icons/ai";
import SendFromMyEmailModal from "../../../components/send-from-my-email/send-from-my-email-modal";
import { InputIcon } from "../../../../components/inputs/input-icon";
import InfoCharge from "../../params/components/info-charge";
import { HiMagnifyingGlass } from "react-icons/hi2";
import toast, { Toaster } from "react-hot-toast";
import AddCollaboratorModal from "./add-collaborator-modal";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../services/atoms/auth.atoms";
import CreateCollaboratorModal from "../../collaborator-details/components/create-modal";
import { useCollaboratorsActions } from "../../../../services/actions/collaborators.actions";
import { useSelectionProcessAction } from "../../../../services/actions/selection-process.actions";
import { selectionProcessAtom } from "../../../../services/atoms/selection-process.atom";
import { HiDotsVertical, HiDownload, HiOutlineEye, HiOutlineLink } from "react-icons/hi";
import { RiSendPlaneLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { HOST_PUBLIC } from "../../../../utils/axios";
import { ROUTES } from "../../../../helpers/constants";
import { getLatestTest, isTestFinished, runTestLinkAction, TEST_LINK_ACTIONS } from "../../../../utils/test-invitation-link";
import TestStatusBadge from "../../../components/test-status-badge/test-status-badge";

// Todas las columnas y acciones usan el test más reciente de la persona: antes se
// usaba tests[0], que según el orden de la consulta podía ser un test antiguo.
const badgeAccessor = (tests) => <TestStatusBadge tests={tests} />;
  const dateFotmatter = (tests) => {
    const finishedAt = getLatestTest(tests)?.finishedAt;
    return (
      <div>
        {finishedAt ? `${moment(finishedAt).format("DD-MM-YYYY HH:mm")} hrs` : "--/--/----"}
      </div>
    );
  };
  
  const columns = [
    {
      Header: "Nombre",
      accessor: ({ name, surname }) => (
        <div>
          {name} {surname}
        </div>
      ),
      disableSortBy: true,
    },
    {
      Header: "Estado",
      accessor: ({ tests }) => badgeAccessor(tests),
      disableSortBy: true,
    },
    {
      Header: " % Match",
      accessor: ({ latestTest }) => <div>-</div>,
    },
    {
      Header: "Realizado el",
      accessor: ({ tests }) => dateFotmatter(tests),
    },
    {
      Header: "Origen",
      accessor: ({ collaboratorInternal }) => (
        <div>{collaboratorInternal ? "Interno" : "Externo"}</div>
      ),
      disableSortBy: true,
    },
    { Header: 'Acciones', accessor: '', disableFilters: true, disableSortBy: true, type: 'actions' },
  ];

  // Copiar link y WhatsApp: si el correo de invitación no llegó (filtros de correo
  // de empresa), el link se reenvía por otro medio sin depender de nadie.
  const options = [
    { id: 'opt-1', title: 'Descargar', action: 'download', icon: HiDownload },
    { id: 'opt-6', title: 'Enviar invitación', action: 'my-email', icon: AiOutlineMail },
    { id: 'opt-7', title: 'Enviar recordatorio', action: 'my-email-reminder', icon: AiOutlineBell },
    { id: 'opt-2', title: 'Reenviar test', action: 'resend', icon: RiSendPlaneLine },
    { id: 'opt-4', title: 'Copiar link del test', action: 'copy-link', icon: HiOutlineLink },
    { id: 'opt-5', title: 'Enviar por WhatsApp', action: 'whatsapp', icon: FaWhatsapp },
    { id: 'opt-3', title: 'Visualizar', action: 'view', icon: HiOutlineEye },
  ];

  const optionsAdminOperative = [
    { id: 'opt-6', title: 'Enviar invitación', action: 'my-email', icon: AiOutlineMail },
    { id: 'opt-7', title: 'Enviar recordatorio', action: 'my-email-reminder', icon: AiOutlineBell },
    { id: 'opt-2', title: 'Reenviar test', action: 'resend', icon: RiSendPlaneLine },
    { id: 'opt-4', title: 'Copiar link del test', action: 'copy-link', icon: HiOutlineLink },
    { id: 'opt-5', title: 'Enviar por WhatsApp', action: 'whatsapp', icon: FaWhatsapp },
    { id: 'opt-3', title: 'Visualizar', action: 'view', icon: HiOutlineEye },
  ];

  const initialSearchValue = { name: "", position: "" };

  const initialSetOpenState = {
    editCharge: false,
    createCollab: false,
    bulk: false,
    errors: false,
    invitation: false,
  };

const DetailSelectionProcess = (props) => {
  const { state } = useLocation();
  const {listCollaborator, resendInvitation}=useCollaboratorsActions()
  const{paginateSelectionProcess}=useSelectionProcessAction()
  const selectionProcess = useRecoilValue(selectionProcessAtom)
  const user = useRecoilValue(userAtom)
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const [collaboratorFilter, setCollaboratorFilter] = useState([])
  const [open, setOpen] = useState(initialSetOpenState);
  const [listCollaborators, setListCollaborators] = useState([]);
  const [rutNewCollab, setRutNewCollab] = useState("");
  // Ventana "Enviar invitación / recordatorio" (null = cerrada).
  const [myEmailTarget, setMyEmailTarget] = useState(null);

  const handleOptionAction = (action, row) => {
    if (action === 'download') {
      // El informe es del último test terminado (si se reenvió uno nuevo, el más
      // reciente puede estar pendiente y el anterior sí tener informe).
      const finishedTest = getLatestTest((row?.tests || []).filter(isTestFinished));
      if (!finishedTest?.id) {
        toast.error('El informe aún no está disponible: la persona todavía no termina su test.');
        return;
      }
      window.open(`${HOST_PUBLIC}/${finishedTest.id}.pdf`, '_blank');
    }
    if(action === 'view' ) navigate(`${ROUTES.PROCESS.route}/collaborator/${row.id}`, { state: { collaborator: row, charge: `${state?.process?.positions[0]?.name}` } });

    if (TEST_LINK_ACTIONS.includes(action)) {
      runTestLinkAction({ action, tests: row?.tests, name: row?.name, phone: row?.phone, email: row?.email, resend: resendInvitation, openMyEmail: setMyEmailTarget });
    }
  };
  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

  const resetSelect = () => {
    const select = document.querySelector('select[name="origen"]');
    select.selectedIndex = 0;
  };
  
  const getCollaborators = async ()=>{
    const response = await listCollaborator({ clientId: user?.data?.clientId })
    if(response){
      setListCollaborators(response?.data)
    }
  }

  const handleChangeOrigin = (event) => {
    event.preventDefault();
    const selectedValue = event.target.value;
    if (selectedValue !== "false") {
      const origin = event.target.value;
      setCollaboratorFilter(state?.process?.collaborators);
      setSearch(origin);
      setCollaboratorFilter(
        state?.process?.collaborators.filter((collab) =>
          origin === "collaboratorInternal"
            ? collab.collaboratorInternal
            : collab.collaboratorExternal
        )
      );
    } else {
      return;
    }
  };
  const handleCleanSearch = () => {
    setCollaboratorFilter(state?.process?.collaborators);
    setSearch("");
    setSearchValue(initialSearchValue);
    resetSelect();
  };

  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSearchByName = (event) => {
    event.preventDefault();
    setCollaboratorFilter(state?.process?.collaborators);
    setSearch(event);
    setCollaboratorFilter(
        state?.process?.collaborators.filter((collab) =>
        collab.name.toLowerCase().includes(searchValues.name.toLowerCase())
      )
    );
  };

  const actions = [
    { icon: HiDotsVertical, dropdown: true }
  ];


  useEffect(()=>{
    setCollaboratorFilter(state?.process?.collaborators)
    //eslint-disable-next-line
  },[])

  useEffect(()=>{
    const actualProcess = selectionProcess?.payload.find((process)=> process.id === state.process?.id)
    if(actualProcess){
        setCollaboratorFilter(actualProcess.collaborators || [])
    }
    //eslint-disable-next-line
  }, [selectionProcess])

  return (
    <div>
        <Toaster />
        <SendFromMyEmailModal target={myEmailTarget} onClose={() => setMyEmailTarget(null)} />
        {open.createCollab &&(
            <CreateCollaboratorModal
            open={open.createCollab}
            toggle={() => handleOpenModal("createCollab")}
            clientId={user?.data?.clientId || ""}
            update={() => getCollaborators()}
            charge={state?.process.positions[0]?.name}
            setRutNewCollab={setRutNewCollab}
            />
        )}
        {open.invitation && (
            <AddCollaboratorModal 
            open={open.invitation}
            toggle={() => handleOpenModal("invitation")}
            clientId={user?.data?.clientId || ""}
            update={() => paginateSelectionProcess({ page:1, limit:10000, clientId: user?.data?.clientId })}
            handleOpenModal={() => handleOpenModal("createCollab")}
            idProcessSelection={state?.process.id || ''}
            charge={state?.process.positions[0]?.name}
            listCollaborators={listCollaborators}
            rutNewCollab={rutNewCollab}
            />
        )}
        <div className="gm-step-container-preview">
          <div className="gm-cd-top-navigation">
            <div className="gm-cd-top-info">
                <>
                  <button
                    onClick={() => {
                      goBack();
                    }}
                    className="gm-cd-back"
                  >
                    Evaluación
                  </button>
                </>
              { state && state?.process?.positions[0]?.name && (
                <>

                  <AiFillCaretRight />
                  <div className="gm-cd-company-info">{`${
                 state?.process?.positions[0]?.name || "Cargo"
                  }`}</div>
                </>
              )}
            </div>
          </div>

          <InfoCharge charge={state && state?.process?.positions[0]} />
          <div style={{ height: "35px" }}></div>
          <div>
            <div className="gm-ts-searchbar-container">
              <div className="gm-ts-searchbar-title-container"></div>
              <div className="gm-ts-searchbar-actions-container">
                <form onSubmit={(e) => handleSearchByName(e, "name")}>
                  <InputIcon
                    Icon={HiMagnifyingGlass}
                    type="text"
                    placeholder="Buscar por nombre"
                    name="search"
                    value={searchValues.name}
                    onChange={(e) => handleChangeValue("name", e.target.value)}
                  />
                </form>
                <form>
                  <div className="gm-input-icon-container">
                    <select
                      name="origen"
                      onChange={(event) => {
                        handleChangeOrigin(event);
                      }}
                    >
                      <option value={false}>Filtrar por origen</option>
                      <option value="collaboratorInternal">Interno</option>
                      <option value="collaboratorExternal">Externo </option>
                    </select>
                  </div>
                </form>
                {searchExists && (
                  <button
                    className="gm-clean-search-button"
                    onClick={handleCleanSearch}
                    type="button"
                  >
                    <AiOutlineClose size={18} />
                  </button>
                )}
                <ButtonLoading
                  className="gm-primary-button"
                  type="button"
                  buttonLabel="Agregar Personas"
                  onClick={() => handleOpenModal("invitation")}
                />
              </div>
            </div>
          </div>
          <TableComponent
            header="primary-green"
            columns={columns}
            data={ collaboratorFilter || []}
            pagination={false}
            loading={selectionProcess.loading}
            actions={actions}
            options={user?.data?.isAdminBasic ? optionsAdminOperative : options}
            handleOptionAction={handleOptionAction}
          />
        </div>
        <div style={{ height: "35px" }}></div>
    </div>
  );
};

export default DetailSelectionProcess;
